import Select from "react-select";
import { convertToDefEventPara } from "../../shared/utility";
import RequiredFieldLabel from "./RequiredFieldLabel";

export default function SelectMenu(props) {
  const {
    ariaLabel,
    error,
    handleInputChange,
    menuPlacement,
    name,
    options,
    defaultValue,
    isMulti,
    title,
    value,
    isClearable,
    disabled,
    parentClass,
    placeholder,
    menuPortalTarget,
    required = false,
  } = props;

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: 40,
      fontSize: 15,
      paddingTop: 0,
    }),
    ...(menuPortalTarget
      ? {
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }
      : {}),
  };

  return (
    <div className={parentClass}>
      {title ? (
        <div className="flex space-x-2 mb-1">
          <label
            htmlFor={name}
            className="block text-sm font-medium text-gray-900"
          >
            <RequiredFieldLabel required={required}>
              {title}
            </RequiredFieldLabel>
          </label>
        </div>
      ) : null}
      <div>
        <Select
          aria-label={ariaLabel}
          menuPortalTarget={menuPortalTarget}
          isMulti={isMulti}
          name={name}
          inputId={name}
          options={options}
          placeholder={placeholder}
          defaultValue={defaultValue}
          value={value}
          menuPlacement={menuPlacement}
          noOptionsMessage={() => `Choose a ${title}`}
          onChange={(val) => {
            handleInputChange(convertToDefEventPara(name, val));
          }}
          styles={customStyles}
          isClearable={isClearable}
          isDisabled={disabled}
          aria-required={required}
        />
        {error ? <p className="font-medium text-red-500">{error}</p> : null}
      </div>
    </div>
  );
}
